import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

import {BookIcon} from "./icons.tsx";

type Props = {
    openModal: () => void;
    setName: string;
};

export const StandardsNavModalLauncher = ({
    openModal,
    setName,
}: Props): React.ReactElement => (
    <View style={styles.mobileOpen}>
        <BookIcon />
        <Strut size={spacing.xSmall_8} />
        <Button kind="tertiary" onClick={openModal}>
            {setName}
        </Button>
    </View>
);

const styles = {
    mobileOpen: {
        flexDirection: "row",
        alignItems: "center",
    },
} as const;
